/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
Shopify.theme.jsAjaxCart = {
  init: function ($section) {

    // Add settings from schema to current object
    Shopify.theme.jsAjaxCart = $.extend(this, Shopify.theme.getSectionData($section));

    if (isScreenSizeLarge() || this.cart_action == 'drawer') {
      this.initializeAjaxCart();
    } else {
      this.initializeAjaxCartOnMobile();
    }

    if (this.cart_action == 'drawer') {

      this.ajaxCartDrawer = $('[data-ajax-cart-drawer]');

      $(document).on('click', '[data-ajax-cart-trigger]', function (e) {
        e.preventDefault();
        Shopify.theme.jsAjaxCart.showDrawer();

        return false;
      });

    } else if (this.cart_action == 'mini_cart') {
      this.showMiniCartOnHover();
    }

    $(document).on('click', '.ajax-submit', function (e) {
      const $addToCartForm = $(this).closest('form');
      const hasZeptoUploads = $addToCartForm.find('.product-personalizer .fileupload').filter(function () {
        return this.files && this.files.length;
      }).length > 0;

      if (hasZeptoUploads) {
        $addToCartForm.find('input[data-zepto-submit-file="true"]').remove();
        $addToCartForm.find('.product-personalizer .fileupload').each(function () {
          const originalName = this.getAttribute('data-apl-original-name');
          if (originalName) {
            this.setAttribute('name', originalName);
          }

          if (typeof window.fileuploadpplr === 'function' && this.files && this.files.length) {
            try {
              window.fileuploadpplr(this, $.Event('change'));
            } catch (_error) {}
          }
        });

        $addToCartForm.find('.product-personalizer .pplr-wrapper').each(function () {
          const $wrapper = $(this);
          const $textField = $wrapper.find('input[name^="properties["]:not(:disabled):not([type="file"]), textarea[name^="properties["]:not(:disabled), select[name^="properties["]:not(:disabled)').first();

          if ($textField.length) {
            let $mirror = $addToCartForm.find(`input[type="hidden"][name="${$textField.attr('name')}"][data-zepto-submit-mirror="true"]`);
            if (!$mirror.length) {
              $mirror = $('<input type="hidden" data-zepto-submit-mirror="true">').attr('name', $textField.attr('name'));
              $addToCartForm.append($mirror);
            }
            $mirror.val($textField.val() || '');
          }
        });

        $addToCartForm.find('.product-personalizer .pplrfileuploadbutton').each(function () {
          const $button = $(this);
          const fileInput = $button.find('.fileupload').get(0);
          const dataName =
            $button.find('.img_url, .crop_img_url').first().attr('data_name')
            || $button.find('.fileupload').attr('data_name')
            || '';
          const previewSrc =
            $button.find('.aplZeptoUploadPreview').attr('src')
            || $button.find('.crop_img_url').attr('src')
            || $button.find('.img_url').attr('src')
            || $button.find('.crop_img_url').attr('data-psrc')
            || $button.find('.img_url').attr('data-psrc')
            || '';

          if (!dataName) {
            return;
          }

          const ensureHiddenField = function (name, value) {
            let $field = $addToCartForm.find(`input[type="hidden"][name="${name}"][data-zepto-submit-mirror="true"]`);
            if (!$field.length) {
              $field = $('<input type="hidden" data-zepto-submit-mirror="true">').attr('name', name);
              $addToCartForm.append($field);
            }
            $field.val(value || '');
          };

          ensureHiddenField(`properties[${dataName} Preview]`, previewSrc && previewSrc.indexOf('blank.png') === -1 ? previewSrc : '');
          ensureHiddenField(`properties[${dataName} File Name]`, fileInput && fileInput.files && fileInput.files[0] ? fileInput.files[0].name : '');
        });

        e.preventDefault();
        $addToCartForm.attr('enctype', 'multipart/form-data');
        $addToCartForm.attr('encoding', 'multipart/form-data');
        HTMLFormElement.prototype.submit.call($addToCartForm[0]);
        return false;
      }

      e.preventDefault();
      Shopify.theme.jsAjaxCart.addToCart($addToCartForm);

      return false;
    });

    $(document).on('click', '[data-ajax-cart-delete]', function (e) {
      e.preventDefault();
      const lineID = $(this).parents('[data-line-item]').data('line-item');
      Shopify.theme.jsAjaxCart.removeFromCart(lineID);

      if (Shopify.theme.jsCart) {
        Shopify.theme.jsCart.removeFromCart(lineID);
      }

      return false;
    });

    $(document).on('click', '[data-ajax-cart-close]', function (e) {
      e.preventDefault();
      Shopify.theme.jsAjaxCart.hideDrawer();
      Shopify.theme.jsAjaxCart.hideMiniCart();

      return false;
    });

    $(document).on('click', '[data-cart-upsell-add]', function (e) {
      e.preventDefault();

      const $button = $(this);
      const variantId = Number($button.data('variant-id'));

      if (!variantId || $button.hasClass('is-loading-focus')) {
        return false;
      }

      const buttonLabel = $button.attr('data-button-label') || $.trim($button.text());
      $button.attr('data-button-label', buttonLabel);
      $button
        .addClass('is-loading-focus')
        .empty()
        .append('<span class="button is-loading is-loading--icon-only"></span>');

      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: {
          id: variantId,
          quantity: 1
        },
        success: function () {
          Shopify.theme.jsAjaxCart.updateView();
          Shopify.theme.jsAjaxCart.showDrawer();
        },
        error: function () {
          $button
            .removeClass('is-loading-focus')
            .empty()
            .append('<span>' + buttonLabel + '</span>');
        }
      });

      return false;
    });

  },
  showMiniCartOnHover: function () {
    const $el = $('[data-ajax-cart-trigger]');

    $el.hover(function() {
      if(Shopify.theme_settings.header_layout == 'centered' && $('.header-sticky-wrapper').hasClass('is-sticky')) {
        $('.header-sticky-wrapper [data-ajax-cart-trigger]').addClass('show-mini-cart');
      } else {
        $el.addClass('show-mini-cart');
      }
    }, function() {
      $el.removeClass('show-mini-cart');
    });
  },
  hideMiniCart: function () {
    if (this.cart_action != 'mini_cart') return false;
    const $el = $('[data-ajax-cart-close]').parents('[data-ajax-cart-trigger]');
    $el.removeClass('show-mini-cart');
  },
  toggleMiniCart: function() {
    const $el = $('.mobile-header [data-ajax-cart-trigger]');

    // Removes url to the cart page so user is not redirected
    $el.attr('href', '#');

    $el.off('touchstart').on('touchstart', function (e) {
      // If user clicks inside the element, do nothing
      if (e.target.closest('[data-ajax-cart-mini_cart]')) {
        return;
      }

      // Loads content into ajaxCart container for mobile header
      Shopify.theme.jsAjaxCart.initializeAjaxCartOnMobile();

      // If user clicks outside the element, toggle the mini cart
      $el.toggleClass('show-mini-cart');
    });
  },
  showDrawer: function () {
    if (this.cart_action != 'drawer') return false;
    this.ajaxCartDrawer.addClass('is-visible');
    $('.ajax-cart__overlay').addClass('is-visible');
    $('html, body').addClass('drawer-open');
  },
  hideDrawer: function () {
    if (this.cart_action != 'drawer') return false;
    this.ajaxCartDrawer.removeClass('is-visible');
    $('.ajax-cart__overlay').removeClass('is-visible');
    $('html, body').removeClass('drawer-open');
  },
  setProcessingState: function (lineID) {
    $('.ajax-cart__panel, .cart__form').addClass('is-cart-processing');

    if (lineID) {
      $(`[data-line-item="${lineID}"]`).addClass('is-cart-processing-item');
    }
  },
  clearProcessingState: function () {
    $('.ajax-cart__panel, .cart__form').removeClass('is-cart-processing');
    $('[data-line-item], [data-cart-item]').removeClass('is-cart-processing-item');
  },
  removeGiftBeforeLastItem: function (lineID) {
    const deferred = $.Deferred();

    $.getJSON('/cart.js')
      .done(function (cart) {
        const targetIndex = Number(lineID) - 1;
        const targetItem = cart.items[targetIndex];

        if (!targetItem) {
          deferred.resolve({
            giftRemoved: false,
            targetKey: null
          });
          return;
        }

        const giftItems = cart.items.filter(function (item) {
          const hasGiftProperty = item.properties && item.properties._apl_free_gift === 'true';
          return hasGiftProperty || (item.product && item.product.handle === window.aplTheme?.freeGiftHandle);
        });
        const nonGiftItems = cart.items.filter(function (item) {
          const hasGiftProperty = item.properties && item.properties._apl_free_gift === 'true';
          return !hasGiftProperty && item.product && item.product.handle !== window.aplTheme?.freeGiftHandle;
        });
        const isRemovingLastRegularItem = nonGiftItems.length === 1 && targetItem && targetItem.product && targetItem.product.handle !== window.aplTheme?.freeGiftHandle;

        if (!isRemovingLastRegularItem || !giftItems.length) {
          deferred.resolve({
            giftRemoved: false,
            targetKey: targetItem.key
          });
          return;
        }

        const updates = {};

        $.each(giftItems, function (_index, item) {
          updates[item.key] = 0;
        });

        $.ajax({
          type: 'POST',
          url: '/cart/update.js',
          data: JSON.stringify({ updates: updates }),
          contentType: 'application/json; charset=UTF-8',
          dataType: 'json',
          success: function () {
            if (typeof Shopify.theme.jsAjaxCart !== 'undefined') {
              Shopify.theme.jsAjaxCart.updateView();
            }

            if (Shopify.theme.jsCart) {
              $.ajax({
                dataType: 'html',
                cache: false,
                url: '/cart',
                success: function (html) {
                  const cartForm = $(html).find('.cart__form');
                  const emptyMessage = $(html).find('.cart__empty-cart-message');

                  if (cartForm.length) {
                    $('.cart__form').replaceWith(cartForm);
                  }

                  if (emptyMessage.length) {
                    $('.cart__empty-cart-message').replaceWith(emptyMessage);
                  }
                }
              });
            }

            deferred.resolve({
              giftRemoved: true,
              targetKey: targetItem.key
            });
          },
          error: function (xhr) {
            deferred.reject(xhr);
          }
        });
      })
      .fail(function (xhr) {
        deferred.reject(xhr);
      });

    return deferred.promise();
  },
  removeFromCart: function (lineID, callback) {
    if ($('.ajax-cart__panel.is-cart-processing, .cart__form.is-cart-processing').length) {
      return false;
    }

    Shopify.theme.jsAjaxCart.setProcessingState(lineID);

    Shopify.theme.jsAjaxCart.removeGiftBeforeLastItem(lineID)
      .done(function (removeState) {
        const targetKey = removeState && removeState.targetKey ? removeState.targetKey : null;
        const requestData = targetKey
          ? JSON.stringify({ updates: { [targetKey]: 0 } })
          : 'quantity=0&line=' + lineID;

        $.ajax({
          type: 'POST',
          url: targetKey ? '/cart/update.js' : '/cart/change.js',
          data: requestData,
          contentType: targetKey ? 'application/json; charset=UTF-8' : 'application/x-www-form-urlencoded; charset=UTF-8',
          dataType: 'json',
          success: function (cart) {
            Shopify.theme.jsAjaxCart.updateView();
            if (window.APLThemeHelpers && typeof window.APLThemeHelpers.syncFreeGiftCart === 'function') {
              window.APLThemeHelpers.syncFreeGiftCart();
            }
          },
          error: function (XMLHttpRequest, textStatus) {
            var response = eval('(' + XMLHttpRequest.responseText + ')');
            response = response.description;
          },
          complete: function () {
            Shopify.theme.jsAjaxCart.clearProcessingState();
          }
        });
      })
      .fail(function () {
        Shopify.theme.jsAjaxCart.clearProcessingState();
      });
  },
  initializeAjaxCart: function () {

    Shopify.theme.asyncView.load(
      Shopify.routes.cart_url, // template name
      'ajax', // view name (suffix)
    )
      .done(({ html, options }) => {

        $('[data-ajax-cart-content]').html(html.content);

        // Converting the currencies
        if (Shopify.theme.currencyConverter) {
          Shopify.theme.currencyConverter.convertCurrencies();
        }

      })
      .fail(() => {
        // some error handling
      });
  },
  initializeAjaxCartOnMobile: function () {

    this.toggleMiniCart();

    Shopify.theme.asyncView.load(
      Shopify.routes.cart_url, // template name
      'ajax', // view name (suffix)
    )
      .done(({ html, options }) => {

        $('.mobile-header [data-ajax-cart-content]').html(html.content);

      })
      .fail(() => {
        // some error handling
      });
  },
  addToCart: function ($addToCartForm) {
    const $addToCartBtn = $addToCartForm.find('.button--add-to-cart');

    if ($addToCartForm.hasClass('is-cart-processing')) {
      return false;
    }

    $addToCartForm.removeClass('shopify-product-form--unselected-error');

    if ($addToCartBtn[0].hasAttribute('data-options-unselected')) {
      const cartWarning = `<p class="cart-warning__message animated bounceIn">${Shopify.translation.select_variant}</p>`;

      $('.warning').remove();

      $addToCartForm
        .addClass('shopify-product-form--unselected-error')
        .find('.cart-warning')
        .html(cartWarning);

      $addToCartBtn
        .removeAttr('disabled')
        .removeClass('disabled');

      $addToCartBtn.find('.icon, .aplAddToCartButtonIcon')
        .removeClass('zoomOut')
        .addClass('zoomIn');

      $addToCartBtn
        .find('.text')
        .text($addToCartBtn.data('label'))
        .removeClass('zoomOut')
        .addClass('zoomIn');
    } else {
      const freeGiftVariantId = Number($addToCartForm.data('free-gift-variant-id')) || 0;
      const addOnVariantIds = $addToCartForm.find('[data-product-addon-toggle]:checked').map(function () {
        return Number($(this).val()) || 0;
      }).get().filter(Boolean);
      const hasCustomUploadProperties = $addToCartForm.find('[data-custom-paddle-upload]').filter(function () {
        return this.files && this.files.length;
      }).length > 0;
      const hasZeptoPersonalizer = $addToCartForm.find('.product-personalizer').length > 0;
      const hasZeptoUploadProperties = $addToCartForm.find('[data-zepto-mirror-file]').filter(function () {
        return this.files && this.files.length;
      }).length > 0;

      function showAddSuccess() {
        let $el = $('[data-ajax-cart-trigger]');

        $addToCartBtn
          .find('.checkmark')
          .addClass('checkmark-active');

        function addedToCart() {
          if (!isScreenSizeLarge()) {
            $el = $('.mobile-header [data-ajax-cart-trigger]');
            Shopify.theme.scrollToTop($el);
          } else {
            $el = $('[data-ajax-cart-trigger]');
          }

          $el.addClass('show-mini-cart');

          $addToCartBtn.find('span')
            .removeClass('fadeInDown');
        }

        window.setTimeout(function () {
          $addToCartBtn
            .removeAttr('disabled')
            .removeClass('disabled');

          $addToCartBtn.find('.checkmark')
            .removeClass('checkmark-active');

          $addToCartBtn.find('.text, .icon, .aplAddToCartButtonIcon')
            .removeClass('zoomOut')
            .addClass('fadeInDown');

          $addToCartBtn.on('webkitAnimationEnd oanimationend msAnimationEnd animationend', addedToCart);
        }, 1000);

        Shopify.theme.jsAjaxCart.showDrawer();
        Shopify.theme.jsAjaxCart.updateView();
        if (window.APLThemeHelpers && typeof window.APLThemeHelpers.syncFreeGiftCart === 'function') {
          window.APLThemeHelpers.syncFreeGiftCart({ showStatus: true });
        }

        if (Shopify.theme.jsCart) {
          $.ajax({
            dataType: "json",
            async: false,
            cache: false,
            dataType: 'html',
            url: "/cart",
            success: function (html) {
              const cartForm = $(html).find('.cart__form');
              $('.cart__form').replaceWith(cartForm);
            }
          });
        }

        if ($.fancybox && typeof $.fancybox.close === 'function') {
          $.fancybox.close();
        }
      }

      function handleAddError(XMLHttpRequest) {
        let response = eval('(' + XMLHttpRequest.responseText + ')');
        response = (response.message) ? response.message : response.description;
        
        const cartWarning = `<p class="cart-warning__message animated bounceIn">${response.replace('All 1 ', 'All ')}</p>`;
        
        $('.warning').remove();

        $addToCartForm
          .find('.cart-warning')
          .html(cartWarning);

        $addToCartBtn
          .removeAttr('disabled')
          .removeClass('disabled');

        $addToCartBtn.find('.icon, .aplAddToCartButtonIcon')
          .removeClass('zoomOut')
          .addClass('zoomIn');

        $addToCartBtn
          .find('.text')
          .text($addToCartBtn.data('label'))
          .removeClass('zoomOut')
          .addClass('zoomIn');
      }

      function addBundledExtras(onSuccess, onError) {
        const extraItems = [];

        $.each(addOnVariantIds, function (_index, variantId) {
          extraItems.push({
            id: variantId,
            quantity: 1
          });
        });

        if (freeGiftVariantId) {
          extraItems.push({
            id: freeGiftVariantId,
            quantity: 1
          });
        }

        if (!extraItems.length) {
          onSuccess();
          return;
        }

        $.ajax({
          url: '/cart/add.js',
          dataType: 'json',
          cache: false,
          type: 'post',
          data: JSON.stringify({ items: extraItems }),
          contentType: 'application/json; charset=UTF-8',
          processData: false,
          success: onSuccess,
          error: onError
        });
      }

      let requestData = $addToCartForm.serialize();
      let requestContentType = 'application/x-www-form-urlencoded; charset=UTF-8';
      let processData = true;

      if (hasZeptoPersonalizer && hasZeptoUploadProperties) {
        requestData = new FormData();
        requestContentType = false;
        processData = false;

        $.each($addToCartForm.serializeArray(), function (_index, field) {
          requestData.append(field.name, field.value);
        });

        $addToCartForm.find('[data-zepto-mirror-file]').each(function () {
          if (this.files && this.files.length) {
            requestData.append(this.name, this.files[0]);
          }
        });
      } else if (hasZeptoPersonalizer) {
        const formFields = $addToCartForm.serializeArray();
        let mainVariantId = null;
        let mainQuantity = 1;
        const properties = {};
        const mainItem = {};

        $.each(formFields, function (_index, field) {
          if (field.name === 'id') {
            mainVariantId = Number(field.value) || null;
          } else if (field.name === 'quantity') {
            mainQuantity = Number(field.value) || 1;
          } else if (field.name.indexOf('properties[') === 0) {
            const propertyName = field.name.replace('properties[', '').replace(']', '');
            properties[propertyName] = field.value;
          } else if (
            field.name !== 'form_type'
            && field.name !== 'utf8'
            && field.name !== 'product-id'
            && field.name !== 'section-id'
          ) {
            mainItem[field.name] = field.value;
          }
        });

        if (mainVariantId) {
          mainItem.id = mainVariantId;
          mainItem.quantity = mainQuantity;

          if (Object.keys(properties).length) {
            mainItem.properties = properties;
          }

          const items = [mainItem];

          $.each(addOnVariantIds, function (_index, variantId) {
            items.push({
              id: variantId,
              quantity: 1
            });
          });

          if (freeGiftVariantId) {
            items.push({
              id: freeGiftVariantId,
              quantity: 1
            });
          }

          requestData = JSON.stringify({
            items: items
          });
          requestContentType = 'application/json; charset=UTF-8';
          processData = false;
        }
      } else if (hasCustomUploadProperties) {
        requestData = new FormData($addToCartForm[0]);
        requestContentType = false;
        processData = false;
      } else if (freeGiftVariantId || addOnVariantIds.length) {
        const formFields = $addToCartForm.serializeArray();
        let mainVariantId = null;
        let mainQuantity = 1;
        const properties = {};
        const mainItem = {};

        $.each(formFields, function (_index, field) {
          if (field.name === 'id') {
            mainVariantId = Number(field.value) || null;
          } else if (field.name === 'quantity') {
            mainQuantity = Number(field.value) || 1;
          } else if (field.name.indexOf('properties[') === 0) {
            const propertyName = field.name.replace('properties[', '').replace(']', '');
            properties[propertyName] = field.value;
          } else if (
            field.name !== 'form_type'
            && field.name !== 'utf8'
            && field.name !== 'product-id'
            && field.name !== 'section-id'
          ) {
            mainItem[field.name] = field.value;
          }
        });

        if (mainVariantId) {
          mainItem.id = mainVariantId;
          mainItem.quantity = mainQuantity;

          if (Object.keys(properties).length) {
            mainItem.properties = properties;
          }

          const items = [mainItem];

          $.each(addOnVariantIds, function (_index, variantId) {
            items.push({
              id: variantId,
              quantity: 1
            });
          });

          if (freeGiftVariantId) {
            items.push({
              id: freeGiftVariantId,
              quantity: 1
            });
          }

          requestData = JSON.stringify({
            items: items
          });
          requestContentType = 'application/json; charset=UTF-8';
          processData = false;
        }
      }

      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: requestData,
        contentType: requestContentType,
        processData: processData,
        beforeSend: function () {
          $addToCartForm.addClass('is-cart-processing');
          $addToCartBtn
            .attr('disabled', 'disabled')
            .addClass('disabled');

          $addToCartBtn.find('.text, .icon, .aplAddToCartButtonIcon')
            .removeClass("fadeInDown")
            .addClass('animated zoomOut');
        },
        success: function () {
          if (hasCustomUploadProperties || hasZeptoUploadProperties || hasZeptoPersonalizer) {
            addBundledExtras(showAddSuccess, handleAddError);
          } else {
            showAddSuccess();
          }
        },
        error: function (XMLHttpRequest) {
          handleAddError(XMLHttpRequest);
        },
        complete: function () {
          $addToCartForm.removeClass('is-cart-processing');
        }
      });
    }
  },
  updateView: function () {

    Shopify.theme.asyncView.load(
      Shopify.routes.cart_url, // template name
      'ajax', // view name (suffix)
    )
    .done(({ html, options }) => {

      if (options.item_count > 0) {
        const freeShipping = $(html.content).find('.ajax-cart__free-shipping');
        const scrollContent = $(html.content).find('.ajax-cart__scroll-content');
        const itemList = $(html.content).find('.ajax-cart__list');
        const cartDetails = $(html.content).find('.ajax-cart__details-wrapper');
        const total_price = options.total_price

        if (freeShipping.length) {
          $('.ajax-cart__free-shipping').replaceWith(freeShipping);
        }
        if (scrollContent.length) {
          $('.ajax-cart__scroll-content').replaceWith(scrollContent);
        }
        $('.ajax-cart__list').replaceWith(itemList);
        $('.ajax-cart__details-wrapper').replaceWith(cartDetails);
        $('.ajax-cart__empty-cart-message').addClass('is-hidden');
        $('.ajax-cart__form').removeClass('is-hidden');
        $('[data-ajax-cart-trigger]').addClass('has-cart-count');
        $('[data-bind="itemCount"]').text(options.item_count);
        
        /* Update shipping indicator asynchronously js */
        if($('[data-fs-threshold]').length){
          let $parent = $('[data-fs-threshold]')
          let $remainingWrapper = $parent.find('.fs-indicator__remaining')
          let $successWrapper = $parent.find('.fs-indicator__success')
          
          let fs_threshold = $('[data-fs-threshold]').data('fs-threshold');
          if(fs_threshold >= total_price){
            //udpate
            let fs_remaining = fs_threshold - total_price;
            let fs_remaining_percent = total_price / fs_threshold * 100
            
            $remainingWrapper.find('.bar').css('width', fs_remaining_percent + '%')
            $remainingWrapper.find('[data-bind="remaining-amount"]').text(Shopify.formatMoney(fs_remaining))
            
            $remainingWrapper.removeClass('is-hidden')
            $successWrapper.addClass('is-hidden')
          }else{
            //remove shipping indicator
            $remainingWrapper.addClass('is-hidden')
            $successWrapper.removeClass('is-hidden')
          }
        }

      } else {
        $('.ajax-cart__empty-cart-message').removeClass('is-hidden');
        $('.ajax-cart__form').addClass('is-hidden');
        $('[data-ajax-cart-trigger]').removeClass('has-cart-count');
        $('[data-bind="itemCount"]').text('0');
      }
      
      if (Shopify.theme.currencyConverter) {
        Shopify.theme.currencyConverter.convertCurrencies();
      }
    })
    .fail(() => {
      // some error handling
    });
  },
  unload: function ($section) {

    // Clear event listeners in theme editor
    $('.ajax-submit').off();
    $('[data-ajax-cart-delete]').off();
  }
}

/******/ })()
;
